// Shared content for North West Asphalt

export const BUSINESS = {
  name: "North West Asphalt",
  tagline: "Family Owned. Paved with Precision.",
  established: "1984",
  yearsExperience: 40,
  phone: "306-604-3882",
  phoneRaw: "3066043882",
  phone2: "+1 (204) 596-9362",
  phone2Raw: "+12045969362",
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/about", label: "About", testId: "nav-about" },
  { to: "/services", label: "Services", testId: "nav-services" },
  { to: "/service-area", label: "Service Area", testId: "nav-service-area" },
  { to: "/gallery", label: "Gallery", testId: "nav-gallery" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export const HERO_BANNERS = [
  {
    src: "https://static.prod-images.emergentagent.com/jobs/d6915d98-2e50-47b4-b5aa-f0e035e67c2f/images/5d5476ac8df590b64a94a70cd734bd7f3d90e7285c667037890e0b70ef78c2a3.png",
    eyebrow: "Established 1984",
    title: "Paving The North",
    subtitle: "Four decades of durable asphalt solutions across Western Canada.",
  },
  {
    src: "https://images.unsplash.com/photo-1774274951965-3828c5cea7c9?fm=jpg&q=85&w=2400&auto=format&fit=crop",
    eyebrow: "Hot Asphalt Paving",
    title: "Built To Last",
    subtitle: "Premium hot-mix asphalt for driveways, lots and roads.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/d6915d98-2e50-47b4-b5aa-f0e035e67c2f/images/b87b4760266773a7b5168e776925f0c833b8e528de4762bf6e24fedfd01a2fb0.png",
    eyebrow: "Protective Seal Coating",
    title: "Seal. Protect. Preserve.",
    subtitle: "Shielding your investment from water, oil and UV damage.",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/d6915d98-2e50-47b4-b5aa-f0e035e67c2f/images/a4b6739a406e7323db5f6b7d925185c88458e929f669a31de3604a3fb67023a3.png",
    eyebrow: "Rubberized Crack Sealing",
    title: "Stop Damage Early",
    subtitle: "Preventative maintenance that extends pavement life.",
  },
];

export const SERVICES = [
  {
    slug: "hot-asphalt-paving",
    title: "Hot Asphalt Paving",
    short:
      "High-quality hot-mix asphalt paving for driveways, roads and commercial lots — smooth, durable surfaces engineered to last.",
    long:
      "Our hot asphalt paving delivers a dense, smooth surface engineered for the freeze-thaw cycles of Western Canada. From residential driveways to commercial lots and rural roads, we handle base prep, grading, compaction and finish paving with precision.",
    image: "/images/IMG_1.jpg",
    points: [
      "Driveways, parking lots, roads",
      "Proper grading & drainage",
      "Heavy-duty compaction",
      "Smooth, finished surface",
    ],
  },
  {
    slug: "protective-seal-coating",
    title: "Protective Seal Coating",
    short:
      "Seal coating protects asphalt from water, oil and UV damage — extending life and restoring that rich, jet-black finish.",
    long:
      "Seal coating is the single most cost-effective way to extend the life of your asphalt. We apply premium sealant that locks out water, oxidation, fuel spills and UV rays — keeping your surface looking brand new for years.",
    image: "/images/IMG_4.jpg",
    points: [
      "UV and oxidation protection",
      "Water & chemical resistance",
      "Restores jet-black finish",
      "Extends pavement lifespan",
    ],
  },
  {
    slug: "rubberized-crack-sealing",
    title: "Rubberized Crack Sealing",
    short:
      "Durable rubberized sealant prevents water intrusion, stops crack growth and extends pavement life.",
    long:
      "Small cracks turn into big problems when water infiltrates the base layer. We inject hot rubberized crack sealant that bonds to asphalt edges, flexes with temperature and blocks water from reaching the foundation.",
    image: "/images/IMG_6.jpg",
    points: [
      "Hot-applied rubberized sealant",
      "Flexes with temperature",
      "Blocks water infiltration",
      "Preventative maintenance",
    ],
  },
  {
    slug: "tar-and-chip",
    title: "Tar and Chip",
    short:
      "A cost-effective alternative to asphalt — liquid asphalt plus stone for a strong, textured, high-traction surface.",
    long:
      "Tar and chip (also known as chip-seal) combines liquid asphalt with crushed stone to create a rugged, attractive, high-traction surface. Ideal for rural driveways, lanes and low-traffic roads where character matters.",
    image: "/images/IMG_8.jpg",
    points: [
      "Natural stone texture",
      "Excellent traction",
      "Budget-friendly alternative",
      "Great for rural driveways",
    ],
  },
  {
    slug: "asphalt-repairs",
    title: "Asphalt Repairs",
    short:
      "Patching, pothole repair and full-depth repair to restore failing sections before they spread.",
    long:
      "From potholes to alligator cracking and failing sections, we provide cut-and-patch, infrared patching and full-depth repair services. We fix the root cause — whether it's drainage, base failure, or worn surface — not just the symptom.",
    image: "/images/IMG_10.jpg",
    points: [
      "Pothole & patch repair",
      "Full-depth reconstruction",
      "Infrared patching",
      "Drainage correction",
    ],
  },
];

export const SERVICE_AREAS = [
  {
    city: "Medicine Hat",
    region: "Alberta",
    province: "AB",
    note: "Southeastern Alberta paving for residential, commercial and industrial clients.",
  },
  {
    city: "Regina",
    region: "Saskatchewan",
    province: "SK",
    note: "Capital of Saskatchewan — driveways, parking lots and municipal contracts.",
  },
  {
    city: "Brandon",
    region: "Manitoba",
    province: "MB",
    note: "Western Manitoba's hub — durable hot-mix asphalt for the prairies.",
  },
  {
    city: "Lloydminster",
    region: "Alberta / Saskatchewan",
    province: "AB · SK",
    note: "Border city coverage for industrial, commercial and oil-sector paving.",
  },
];

const STOCK_PAVING = [
  "https://images.unsplash.com/photo-1708117390188-d1547de962be?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1708117242652-25dc76c4b30c?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1773118330236-d812832b5b71?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1772852340517-b11ec88979fc?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1772852311587-329719989e2b?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1776381733574-372689e246b4?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1763328044351-98341e9963da?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1724648179736-fef1ae010d6b?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1772852327572-d6344152e6ba?fm=jpg&q=80&w=1600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1760708626681-59a5373819a6?fm=jpg&q=80&w=1600&auto=format&fit=crop",
];

export const GALLERY_IMAGES = [
  ...Array.from({ length: 12 }, (_, i) => ({
    src: `/images/IMG_${i + 1}.jpg`,
    alt: `North West Asphalt project ${i + 1}`,
  })),
  ...STOCK_PAVING.map((src, i) => ({
    src,
    alt: `North West Asphalt paving work ${i + 13}`,
  })),
];

export const TESTIMONIALS = [
  {
    quote:
      "North West Asphalt rebuilt our driveway the right way — proper base prep and drainage. Three winters in and it still looks brand new.",
    name: "Homeowner",
    location: "Medicine Hat, AB",
  },
  {
    quote:
      "Professional crew, honest pricing, and a finish that speaks for itself. They treat every job like it's their own driveway.",
    name: "Commercial Client",
    location: "Regina, SK",
  },
  {
    quote:
      "We hired them for our acreage drive and a parking pad. Crew was on time, prep was thorough, and the surface looks fantastic.",
    name: "Property Owner",
    location: "Brandon, MB",
  },
  {
    quote:
      "We've worked with North West Asphalt on multiple oil-sector lots. Always on schedule, always on budget, always quality work.",
    name: "Property Manager",
    location: "Lloydminster, AB/SK",
  },
];

export const STATS = [
  { value: "40+", label: "Years in Business" },
  { value: "1984", label: "Family Owned Since" },
  { value: "5★", label: "Client Rated" },
  { value: "3", label: "Regions Served" },
];
